import _, { cloneDeep } from 'lodash';
import { getFormattedValues } from './formatData';
import { DOWNLOAD_STATUS } from '../constants/appConstants';
import store from '../store/appStore';
import { SET_DOWNLOADING_VISIBILITY, SET_FILEDOWNLOADING } from '../store/progressBar/actionTypes';
import { removeDuplicates, getRoundedValueUptoTwoDecimal } from './helper';

const getMultilevelGroupedDataForBilling = (data, groupBy) => {
  let groupedData = _.cloneDeep(data);
  if (groupBy !== undefined && groupBy[0] !== undefined) {
    groupedData = getGroupValues1(groupedData, groupBy[0], groupBy);
  }
  return (groupedData);
};

const getGroupValues1 = (data, key, groupBy) => {
  groupBy = groupBy.filter(x => x !== key);
  const nextKey = groupBy[0];
  return _.chain(data).groupBy(key).map(function (v, i) {
    return {
      key: key,
      [key]: i,
      data: (nextKey !== undefined) ? getGroupValues1(v, nextKey, groupBy) : v,
      billedToCompany: _.chain(v).sumBy(x => x.billedToCompany).value(),
      billedToProperty: _.chain(v).sumBy(x => x.billedToProperty).value(),
      unreimbursedPayrollCost: _.chain(v).sumBy(x => x.unreimbursedPayrollCost).value(),
      isGroup: true
    };
  }).value();
};

const getMultilevelGroupedData = (data, groupBy, isReimbursed = false, allocationType = '') => {
  // console.log('getMultilevelGroupedData started'+ new Date());
  let groupedData = cloneDeep(data);
  if (groupBy !== undefined && groupBy[0] !== undefined) {
    groupedData = getGroupValues(groupedData, groupBy[0], groupBy, isReimbursed, allocationType);
  }
  // console.log('getMultilevelGroupedData ended '+ new Date());
  return (groupedData);
};

const getGroupValues = (data, key, groupBy, isReimbursed, allocationType) => {  
  groupBy = groupBy.filter(x => x !== key);
  const nextKey = groupBy[0];
  return _.chain(data).groupBy(key).map(function (v, i) {
    if (isReimbursed) {
      return {
        key: key,
        [key]: i,
        data: (nextKey !== undefined) ? getGroupValues(formatChildRow(v, key), nextKey, groupBy, isReimbursed) : formatChildRow(v, key),
        reimbursmentDetails: getReimbursementSummary(v, isReimbursed, allocationType),
        isGroup: true
      };
    } else {
      return {
        key: key,
        [key]: i,
        data: (nextKey !== undefined) ? getGroupValues(v, nextKey, groupBy, isReimbursed) : v
      };
    }
  }).value();
};

const formatChildRow = (data, key) => {
  data?.forEach((o, ind) => {
    if (ind > 0) {
      o[key] = '';
    }
  });
  return data;
};
function getReimbursementSummary(data, isReimbursed, allocationType) {
  let resultArray;
  if (isReimbursed) {
    const reimburseData = data.map(obj => obj.reimbursmentDetails);
    const merged = [].concat.apply([], reimburseData);
    // const payCycle = removeDuplicates(data[0].reimbursmentDetails.map(x => x.payPeriod));
    let payCycles = [];
    (data || []).forEach(d=> d.reimbursmentDetails.forEach(r => payCycles.push(r.payPeriod)));
    payCycles = _.orderBy(removeDuplicates(payCycles));

    payCycles.forEach(cycle => {
      const detailObj = {};
      detailObj.payPeriod = cycle;
      detailObj.isSummary = true;
      detailObj.reimbursementCost = getRoundedValueUptoTwoDecimal(_.chain(merged.filter(x => x.payPeriod === cycle)).sumBy(x => x.reimbursementCost).value());
      // detailObj.allocationRate = _.chain(merged.filter(x => x.payPeriod === cycle)).sumBy(x => x.allocationRate).value();
      // detailObj.allocationRate = getValue(merged.filter(x => x.payPeriod === cycle), 'allocationRate', allocationType);
      // detailObj.burdenRatePercent = _.chain(merged.filter(x => x.payPeriod === cycle)).sumBy(x => x.burdenRatePercent).value();
      // detailObj.burdenRatePercent = getUniqueValue(merged.filter(x => x.payPeriod === cycle), 'burdenRatePercent');
      detailObj.flatrate = getRoundedValueUptoTwoDecimal(_.chain(merged.filter(x => x.payPeriod === cycle)).sumBy(x => x.flatrate).value());
      // detailObj.propertyBillingPercent = _.chain(merged.filter(x => x.payPeriod === cycle)).sumBy(x => x.propertyBillingPercent).value();
      // detailObj.propertyBillingPercent = getValue(merged.filter(x => x.payPeriod === cycle), 'propertyBillingPercent');
      detailObj.expenseAmount = getRoundedValueUptoTwoDecimal(_.chain(merged.filter(x => x.payPeriod === cycle)).sumBy(x => x.expenseAmount).value());
      detailObj.burdenAmount = getRoundedValueUptoTwoDecimal(_.chain(merged.filter(x => x.payPeriod === cycle)).sumBy(x => x.burdenAmount).value());
      if (resultArray === undefined) {
        resultArray = [];
      }
      resultArray.push(detailObj);
    });
  }
  return resultArray;
}

function getUniqueValue(data, key) {
  // const distinctEmployees = _.chain(data.map((obj) => ({ id: obj.employeeId, propertyId: obj.propertyId, value: obj[key] }))).value();
  const distinctEmployees = _.chain(data.map((obj) => ({ id: obj.employeeId, value: obj[key] }))).value();
  return _.chain(unique(distinctEmployees, ['id'])).sumBy(x => x.value).value();
}

function getValue(data, key, allocationType) {
  if (allocationType === 'Market') {
    const distinctEmployees = _.chain(data.map((obj) => ({ id: obj.employeeId, marketId: obj.marketId, divisionId: obj.divisionId, departmentId: obj.departmentId, value: obj[key] }))).value();
    return _.chain(unique(distinctEmployees, ['id', 'marketId', 'divisionId', 'departmentId'])).sumBy(x => x.value).value();
  } else {
    const distinctEmployees = _.chain(data.map((obj) => ({ id: obj.employeeId, propertyId: obj.propertyId, value: obj[key] }))).value();
    return _.chain(unique(distinctEmployees, ['id', 'propertyId'])).sumBy(x => x.value).value();
  }
}

function unique(arr, keyProps) {
  return Object.values(arr.reduce((uniqueMap, entry) => {
    const key = keyProps.map(k => entry[k]).join('|');
    if (!(key in uniqueMap)) uniqueMap[key] = entry;
    return uniqueMap;
  }, {}));
}

function setDownloadingStatus(
  downloadingKey = '',
  fileName = '',
  status = 'downloading',
  errorMessage = '',
  statusMessage = ''
) {
  store.dispatch({
    type: SET_FILEDOWNLOADING,
    payload: {
      details: {
        dKey: downloadingKey,
        fileName: fileName,
        status: DOWNLOAD_STATUS[status],
        errorMessage: errorMessage,
        statusMessage: statusMessage
      }
    }
  });
}

function generateString(length) {
  const characters =

    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  let result = ' ';

  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
}

function visibilityDownloaderProgress(flag = false) {
  store.dispatch({

    type: SET_DOWNLOADING_VISIBILITY,

    payload: flag

  });
}

export {
  getMultilevelGroupedData,
  getMultilevelGroupedDataForBilling,
  setDownloadingStatus,
  generateString,
  visibilityDownloaderProgress
};

// parseJwt(localStorage.getItem("adal.idtoken"));
// generic js
